import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const purchaseOrderFiltersGet = async (view_type = 'por', signal, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.filters}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { view_type },
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const purchaseOrderSummary = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.summary}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const purchaseOrderList = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.list}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// downloadPO
const purchaseOrderExportpdfIdGet = async (id, regenerate, hasGrace = false, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.exportPDF}/${id}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { regenerate, hasGrace },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderOptionsGet
const purchaseOrderOptionsGet = async (po_type = 'DOMESTIC_PO', buyerEntityCode, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.options}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { po_type, buyer_entity_code: buyerEntityCode },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdDetailsGet
const purchaseOrderIdDetailsGet = async (POId, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${POId}${Constants.PATH.PURCHASE_ORDER.details}`;

  try {
    const res = await api_request({ methodType: 'get', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderGet
// asn_grn_po_search
const purchaseOrderGet = async (params, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdCommentsDownloadGet - rejection reason
const purchaseOrderIdCommentsDownloadGet = async (comments, id, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.commentsDownload}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { comments },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdExportCsvGet
const purchaseOrderIdExportCsvGet = async (id, has_grace = false, options, type) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.exportCSV}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { has_grace, csv_type: type },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdGet - edit
const purchaseOrderIdGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}`;

  try {
    const res = await api_request({ methodType: 'get', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderSkuSampleGet
const purchaseOrderSkuSampleGet = async (type, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}${Constants.PATH.PURCHASE_ORDER.skuSample}`;

  try {
    const res = await api_request({
      methodType: 'get',
      params: { po_type: type },
      resourcePath,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// Update SKU Quantity Sample
const updateSkuQuantitySampleGet = async (options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}${Constants.PATH.PURCHASE_ORDER.updateQtySample}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdSampleCommentDownloadGet
const purchaseOrderIdSampleCommentDownloadGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.sampleCommentDownload}`;

  try {
    const res = await api_request({ methodType: 'get', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const purchaseOrderIdSKUValidateCloneGet = async (cloneId, newId, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${cloneId}${Constants.PATH.PURCHASE_ORDER.skuValidateClone}?new_po_id=${newId}`;

  try {
    const res = await api_request({ methodType: 'get', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// post
// purchaseOrderIdCommentsUploadPost
const purchaseOrderIdCommentsUploadPost = async (remarks, comment_type, id, file, options, validate_only = false) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.commentsUpload}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { remarks, comment_type, validate_only },
      data: { file },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdFilesSubmitPost
const purchaseOrderIdFilesSubmitPost = async (data, id, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.filesSubmit}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdForceClosePost
const purchaseOrderIdForceClosePost = async (id, reason, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.forceClose}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { reason },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdSkuValidatePost
const purchaseOrderIdSkuValidatePost = async (id, file, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.validateSKU}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data: { file },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderNewPost
const purchaseOrderNewPost = async (data, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.new_po_order}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const purchaseOrderNewInterEntityPost = async (data, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.new_inter_entity_po_order}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// PUT
// purchaseOrderIdSyncPut
const purchaseOrderIdSyncPut = async (id, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.sync}`;

  try {
    const res = await api_request({ methodType: 'put', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdUpdatePut
const purchaseOrderIdUpdatePut = async (data, id, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.updatePO}`;

  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// purchaseOrderIdEventEventPut
const purchaseOrderIdEventEventPut = async (id, event, options) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.event}/${event}`;

  try {
    const res = await api_request({ methodType: 'put', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// validate update qty
const skuValidateUpdateQty = async (id, file) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.skuValidateUpdateQty}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data: { file }
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// update qty
const skuSubmitUpdateQty = async (id, fileId, remarks) => {
  const resourcePath = `${Constants.PATH.PURCHASE_ORDER.po_order}/${id}${Constants.PATH.PURCHASE_ORDER.skuSubmitUpdateQty}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data: {
        file_id: fileId,
        remarks
      }
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export {
  purchaseOrderFiltersGet,
  purchaseOrderSummary,
  purchaseOrderList,
  purchaseOrderExportpdfIdGet,
  purchaseOrderOptionsGet,
  purchaseOrderIdDetailsGet,
  purchaseOrderGet,
  purchaseOrderIdCommentsDownloadGet,
  purchaseOrderIdExportCsvGet,
  purchaseOrderIdGet,
  purchaseOrderSkuSampleGet,
  purchaseOrderIdSampleCommentDownloadGet,
  purchaseOrderIdCommentsUploadPost,
  purchaseOrderIdFilesSubmitPost,
  purchaseOrderIdForceClosePost,
  purchaseOrderIdSkuValidatePost,
  purchaseOrderIdSyncPut,
  purchaseOrderIdUpdatePut,
  purchaseOrderNewPost,
  purchaseOrderIdEventEventPut,
  skuValidateUpdateQty,
  skuSubmitUpdateQty,
  updateSkuQuantitySampleGet,
  purchaseOrderIdSKUValidateCloneGet,
  purchaseOrderNewInterEntityPost
};
